import { useState } from "react";

import { classNames } from "src/utils/classNames";
import styles from "../../Table.module.css";
import { Column, RowData } from "../../types";

interface Props<T extends RowData> {
  columns: Column<T>[];
  rowData: T;
  gridRow: number;
  onClick?: (rowData: T) => void;
}

export const Row = <T extends RowData>({
  columns,
  rowData,
  gridRow,
  onClick,
}: Props<T>) => {
  const [hovered, setHovered] = useState(false);

  return (
    <tr
      key={rowData.id}
      className={classNames(styles.tableRow, styles.subgrid)}
      style={{
        gridRow,
      }}
      onClick={onClick && (() => onClick(rowData))}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {columns.map(({ cell }, index) => {
        return (
          <td key={index} className={styles.tableCell}>
            {cell(rowData, { rowHovered: hovered })}
          </td>
        );
      })}
    </tr>
  );
};
